import { Link } from "react-router-dom";
import { useAuthUser } from "../../hooks/useAuthUser";
import { useContext } from "react";
import { HamburgerMenuContext } from "../../store/HamburgerMenuContext";
import { PublicNavHamburgerLinks } from "../../../PublicNavLinks";

const PublicMenuContent = () => {
  const {
    isAuthenticated,
    isAdmin,
    isBusiness,
    isEmployee,
    hasCSASubscription,
    isSocial,
    logout,
  } = useAuthUser();
  const { closeHamburgerMenu } = useContext(HamburgerMenuContext);
  const location = window.location.pathname;

  return (
    <div className="menu-content hidden-scrollbar">
      <div className="nav-menu">
        <PublicNavHamburgerLinks
          pathname={location}
          onNavigate={closeHamburgerMenu}
        />
      </div>

      {isAuthenticated ? (
        <div className="personal-menu-links-container">
          <Link className="nav-link" to="/profile" onClick={closeHamburgerMenu}>
            Profile
          </Link>
          {(isAdmin || isBusiness || isEmployee || hasCSASubscription) && (
            <Link
              className="nav-link"
              to="/dashboard"
              onClick={closeHamburgerMenu}
            >
              {isSocial && hasCSASubscription
                ? "My Subscription"
                : isBusiness
                  ? "My Orders"
                  : "Dashboard"}
            </Link>
          )}
          <div>
            <Link
              className="nav-link"
              to="/"
              onClick={() => {
                logout();
                closeHamburgerMenu();
              }}
            >
              Log out
            </Link>
          </div>
        </div>
      ) : (
        <div className="personal-menu-links-container">
          <Link className="nav-link" to="/login" onClick={closeHamburgerMenu}>
            Log in
          </Link>
          <Link className="nav-link" to="/signup" onClick={closeHamburgerMenu}>
            Sign up
          </Link>
        </div>
      )}
    </div>
  );
};

export default PublicMenuContent;
